import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import locationApi from '../../utils/locationApi'

import config from '../../config'
import { Button, Modal, InputGroup, FormControl, Spinner } from 'react-bootstrap'

const urlVehicle = config.api.baseUrl + '/vehicles'
const urlBranch = config.api.baseUrl + '/branches'

const AddVehichleModal = (props) => {
  const { show, onClose } = props

  const [branches, setBranches] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    (async () => {
      const res = await locationApi('get', urlBranch)
      setLoading(false)
      setBranches(res.data)
    })()
  }, [])

  const handleSubmit = useCallback(
    async (data, { resetForm }) => {
      try {
        await locationApi('post', urlVehicle, data)
        onClose()
        resetForm()
        toast('Succesfully updated.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
      } catch (err) {
        onClose()
        toast.error(`${err}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
        console.log(err)
      }
    }, [onClose])

  return (
    <>
      <Formik
        initialValues={{
          pmId: '',
          reg: '',
          branches: branches,
          cseId: '',
          pipelineId: '',
          acetrackId: ''
        }}
        onSubmit={handleSubmit}

      >{
          ({ values, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Modal show={show} onHide={onClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Vehicle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {loading
                    ? <Spinner animation='border' />
                    : (
                      <>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>PMID</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl
                            name='pmId'
                            value={values.pmId}
                            onChange={handleChange}
                          />
                        </InputGroup>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Registration No.</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl
                            name='reg'
                            value={values.reg}
                            onChange={handleChange}
                          />
                        </InputGroup>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Branch</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl as='select' multiple custom value={values.branches || []} name='branches' onChange={handleChange}>
                            {
                              branches?.map(branch => {
                                return (<option key={branch.name} value={branch.name}>{branch.name}</option>)
                              })
                            }
                          </FormControl>
                        </InputGroup>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>CSE ID</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl
                            name='cseId'
                            value={values.cseId}
                            onChange={handleChange}
                          />
                        </InputGroup>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Pipe Line ID</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl
                            name='pipelineId'
                            value={values.pipelineId}
                            onChange={handleChange}
                          />
                        </InputGroup>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Acetrack ID</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl
                            name='acetrackId'
                            value={values.acetrackId}
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    disabled={!values.pmId || !values.reg || !values.branches}
                    onClick={handleSubmit}
                  >
                    Add Vehicle
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>
          )
        }
      </Formik>
    </>
  )
}

export default AddVehichleModal

AddVehichleModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func
}
